export default "<notifier-container></notifier-container>\n<ngx-ui-loader></ngx-ui-loader>\n\n<router-outlet></router-outlet>"